import { defineMessages } from "@formatjs/intl"
import type { VehicleType } from "."

export const vehicleTypeShortMessages = defineMessages<VehicleType>({
	COMMISSION_CAR: {
		defaultMessage: "COM",
		id: "vehicle.vehicleType.commissionCar.short",
	},
	COMPANY_CAR: {
		defaultMessage: "CC",
		id: "vehicle.vehicleType.companyCar.short",
	},
	CUSTOMER_REPLACEMENT_CAR: {
		defaultMessage: "SL",
		id: "vehicle.vehicleType.serviceLoaner.short",
	},
	DEMO_CAR: {
		defaultMessage: "DC",
		id: "vehicle.vehicleType.demoCar.short",
	},
	NEW_CAR: {
		defaultMessage: "NC",
		id: "vehicle.vehicleType.newCar.short",
	},
	USED_CAR: {
		defaultMessage: "UC",
		id: "vehicle.vehicleType.usedCar.short",
	},
})
